const dynamicRangeOutputElements = document.querySelectorAll('[data-range-output]');

const updateRangeOutput = (element, value) => {
    const format = element.dataset.rangeFormat || '{value}';
    element.textContent = format.replace('{value}', value);
};

dynamicRangeOutputElements.forEach(element => {
    const input = document.getElementById(element.dataset.rangeOutput);
    updateRangeOutput(element, input.value);
    input.addEventListener('input', e => updateRangeOutput(element, e.target.value));
});
